import axios from "axios";
import { auth } from "./firebase";
import { API_BASE_URL } from "./config";
import { ReservationCreate, ReservationResponse, ScheduleSlot } from "./api_types";

// Create axios instance with default config
export const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
    },
    withCredentials: true,
  });

  api.interceptors.request.use(
    async (config) => {
      const user = auth.currentUser;
      if (user) {
        const token = await user.getIdToken();
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

// Reservation API
export const reservationApi = {
    createReservation: async (businessId: string, facilityId: string, data: ReservationCreate): Promise<ReservationResponse> => {
      const response = await api.post(`/api/businesses/${businessId}/facilities/${facilityId}/reservations`, data, {
        params: { facility_id: facilityId }
      });
      return response.data;
    },
  
    deleteReservation: async (businessId: string, facilityId: string, reservationId: string): Promise<void> => {
      await api.delete(`/api/businesses/${businessId}/facilities/${facilityId}/reservations/${reservationId}`, {
        params: { facility_id: facilityId }
      });
    },
  
    updateReservation: async (businessId: string, facilityId: string, reservationId: string, data: ReservationCreate): Promise<ReservationResponse> => {
      const response = await api.put(`/api/businesses/${businessId}/facilities/${facilityId}/reservations/${reservationId}`, data, {
        params: { facility_id: facilityId }
      });
      return response.data;
    },
    
    getMemberSchedule: async (facilityId: string, date: string, businessId: string): Promise<ScheduleSlot[]> => {
      const response = await api.get(`/api/businesses/${businessId}/facilities/${facilityId}/schedules`, {
        params: { date }
      });
      return response.data;
    },
  
    checkTimeConflicts: async (businessId: string, facilityId: string, params: {
      courtId: string;
      date: string;
      startTime: string;
      endTime?: string;
      excludeEventId?: string;
      excludeRecurringEventId?: string;
      excludeReservationId?: string;
      checkRecurringEvents?: boolean;
      checkOneTimeEvents?: boolean;
      checkReservations?: boolean;
      checkClasses?: boolean;
    }): Promise<{ hasConflict: boolean; conflictMessage?: string; conflictingEvent?: any }> => {
      const response = await api.post(`/api/businesses/${businessId}/facilities/${facilityId}/check-conflicts`, params);
      return response.data;
    },
  };